import { Button, Group, NumberInput, Stack, Text } from '@mantine/core';
import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { useFormContext } from '../../../contexts/formContext';
import { RequiredSetting } from '../../../components/RequiredSetting';

type FacesSettingType = 'count' | 'percentage';

export function FacesSetting() {
  const form = useFormContext();

  const selectedOption = typeof form.getValues().limits?.faces?.percentage === 'number' ? 'percentage' : 'count';

  const onFacesOptionChanged = (option: FacesSettingType) => {
    switch (option) {
      case 'count':
        form.setValues((prev) => ({
          limits: { ...prev.limits, faces: { count: 0 } },
        }));
        return;
      case 'percentage':
        form.setFieldValue('limits.faces', { percentage: 50 });
        return;
      default:
        const exhaustiveCheck: never = option;
    }
  };

  return (
    <RequiredSetting title='Face count'>
      <Group gap='xs'>
        <Button
          variant={selectedOption === 'count' ? 'filled' : 'outline'}
          onClick={() => onFacesOptionChanged('count')}
        >
          Face count
        </Button>
        <Button
          variant={selectedOption === 'percentage' ? 'filled' : 'outline'}
          onClick={() => onFacesOptionChanged('percentage')}
        >
          Face percentage
        </Button>
      </Group>
      {selectedOption === 'count' && (
        <Group>
          <Text>Max face limit:</Text>
          <NumberInput {...form.getInputProps('limits.faces.count')} />
        </Group>
      )}
      {selectedOption === 'percentage' && (
        <Stack>
          <Group>
            <Text>Percentage of faces</Text>
            <NumberInput {...form.getInputProps('limits.faces.percentage')} />
          </Group>
          <SimpleSlider {...form.getInputProps('limits.faces.percentage')} min={0} max={100} defaultValue={0} />
        </Stack>
      )}
    </RequiredSetting>
  );
}
